type FolderWithMailVisibilityFields = {
  docIds?: readonly string[] | null;
  systemKind?: string | null;
};

type DocGroupWithDocId = {
  docId: string;
};

type ExplorerGroupWithItems = {
  items: string[];
};

const PERSONAL_MAIL_FOLDER_SYSTEM_KIND = 'private_mail';
const TEAM_MAILBOXES_FOLDER_SYSTEM_KIND = 'team_mailboxes_folder';

export const EMPTY_HIDDEN_MAIL_FOLDER_DOC_IDS = new Set<string>();

export function isMailboxWorkspaceFolder(
  folder: FolderWithMailVisibilityFields
): boolean {
  return (
    folder.systemKind === PERSONAL_MAIL_FOLDER_SYSTEM_KIND ||
    folder.systemKind === TEAM_MAILBOXES_FOLDER_SYSTEM_KIND
  );
}

export function resolveHiddenMailFolderDocIds(
  folders: readonly FolderWithMailVisibilityFields[],
  visibleMailboxRootDocIds: ReadonlySet<string>
): ReadonlySet<string> {
  const hiddenDocIds = new Set<string>();
  for (const folder of folders) {
    if (!isMailboxWorkspaceFolder(folder)) continue;
    for (const docId of folder.docIds ?? []) {
      if (!visibleMailboxRootDocIds.has(docId)) {
        hiddenDocIds.add(docId);
      }
    }
  }
  return hiddenDocIds;
}

export function filterDocGroupsForHiddenMailFolderDocIds<
  T extends DocGroupWithDocId,
>(groups: readonly T[], hiddenDocIds: ReadonlySet<string>): T[] {
  if (hiddenDocIds.size === 0) return [...groups];
  return groups.filter(group => !hiddenDocIds.has(group.docId));
}

export function filterExplorerGroupsForHiddenMailFolderDocIds<
  T extends ExplorerGroupWithItems,
>(groups: readonly T[], hiddenDocIds: ReadonlySet<string>): T[] {
  if (hiddenDocIds.size === 0) return [...groups];
  return groups
    .map(group => ({
      ...group,
      items: group.items.filter(docId => !hiddenDocIds.has(docId)),
    }))
    .filter(group => group.items.length > 0);
}
